import { Observer } from 'mobx-react';
import * as React from 'react';

import { DeleteModal } from 'src/modules/transferRegistration/components/DeleteModal';
import { openDeleteModalStore } from 'src/modules/transferRegistration/stores';

export const BaseDelete = () => {
  return <Observer>{() => (openDeleteModalStore.value ? <DeleteModal open={openDeleteModalStore.value} /> : null)}</Observer>;
};
